import React, { useRef, useState } from "react";
import { Spinner, RainbowThemeContainer } from "react-rainbow-components";
import { errorToaster } from "../../../../reusable/common";
import { uploadFile } from "../../../../revampCRUD/uploads.crud";
import CropModal from "./CropModal";
import { CustomModal } from "../../../Atom/Modals";
import { MAX_IMAGE_UPLOAD_SIZE } from "../../../../config/constants";

const theme = {
	rainbow: {
		palette: {
			brand: "#002E6E"
		}
	}
};

const FileUpload = ({
	children,
	onChange,
	disabled,
	moduleNumber,
	onlyCrop = false,
	noCrop = false,
	acceptType = "image/*",
	aspect = 4 / 3,
	maxFileSizeMB = MAX_IMAGE_UPLOAD_SIZE,
	...props
}) => {
	const [file, setFile] = useState(null);
	const [uploading, setUploading] = useState(false);
	const [cropModal, setCropModal] = useState(false);

	const fileInputRef = useRef(null);

	const acceptedImageTypes = ["image/gif", "image/jpeg", "image/png", "image/webp"];

	const openFileSelector = () => {
		if (fileInputRef) fileInputRef.current?.click();
	};

	const onFileChange = e => {
		try {
			if (e.target.files[0].size / 1024 / 1024 > maxFileSizeMB) {
				errorToaster(
					`Image size is greater than ${maxFileSizeMB}MB. It should be less than ${maxFileSizeMB}MB.`
				);
				return;
			}
			setFile(e.target.files[0]);
			if (noCrop) {
				doUploadFile(e.target.files[0])
			}
			else if (acceptedImageTypes.includes(e.target.files[0].type)) {
				setCropModal(true)
			}
			else if (!acceptedImageTypes.includes(e.target.files[0].type)) {
				errorToaster("Oops! That file type isn't supported. Please choose an image in GIF, JPEG, PNG, or WebP format.");
				setFile(null);
			}
		} catch (err) {
			console.log(err);
			errorToaster("Something went wrong. Please try again later");
		}
		 e.target.value = null;
	};

	const doUploadFile = async fileValue => {
		try {
			setUploading(true);
			const downloadUrl = await uploadFile(fileValue, moduleNumber);
			setUploading(false);
			closeCropModal();
			if (onChange) onChange(downloadUrl, window.URL.createObjectURL(fileValue));
		} catch (err) {
			setUploading(false);
			const error =
				err?.response?.data?.message ||
				err?.message ||
				"Something went wrong. Please try again later";
			errorToaster(error);
		}
	};

	const closeCropModal = () => {
		setCropModal(false);
		setFile(null);
		fileInputRef.current.value = "";
	};

	return (
		<>
			{cropModal && (
				<CropModal
					onlyCrop={onlyCrop}
					file={file}
					closeCropModal={closeCropModal}
					doUploadFile={doUploadFile}
					cropModal={cropModal}
					uploading={uploading}
					aspect={aspect}
				/>
			)}
			{uploading && (
				<CustomModal
					openModal={uploading}
					header={null}
					noClose={true}
					content={
						<>
							<div className="spinner d-flex justify-content-center align-items-center p-5">
								<RainbowThemeContainer theme={theme}>
									<Spinner size="large" type="arc" variant="brand" />
								</RainbowThemeContainer>
							</div>
						</>
					}
				/>
			)}
			<div className="file-upload">
				<input
					type="file"
					accept={acceptType}
					onChange={onFileChange}
					disabled={disabled || uploading}
					className={children ? "d-none" : ""}
					ref={fileInputRef}
					{...props}
				/>
				<div onClick={openFileSelector} className="d-inline-block w-100">
					{children}
				</div>
			</div>
		</>
	);
};

export default FileUpload;
